import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Home } from './pages/Home';
import { MetaPixel } from './components/MetaPixel';
export function App() {
  return <div className="flex flex-col w-full min-h-full bg-white" data-id="element-0">
      <MetaPixel data-id="element-1" />
      <BrowserRouter data-id="element-2">
        <Routes data-id="element-3">
          <Route path="/" element={<Home data-id="element-5" />} data-id="element-4" />
          {/* Redirect any other routes to home */}
          <Route path="*" element={<Navigate to="/" replace data-id="element-7" />} data-id="element-6" />
        </Routes>
      </BrowserRouter>
    </div>;
}